export const ORDERS_REPORT_CARD_CHART_X_COLOR = '#CED4DA'
export const ORDERS_REPORT_CARD_CHART_Y_COLOR = '#A9AEAA'
